import { render, staticRenderFns } from "./RestrictionsModal.vue?vue&type=template&id=41ffdf60&scoped=true&"
import script from "./RestrictionsModal.vue?vue&type=script&lang=js&"
export * from "./RestrictionsModal.vue?vue&type=script&lang=js&"
import style0 from "./RestrictionsModal.vue?vue&type=style&index=0&id=41ffdf60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ffdf60",
  null
  
)

export default component.exports